<template>
  <div class="app-container">
    <!-- 顶部按钮 -->
    <div class="top_btns clearfix">
      <div class="left_search fl">
        <qzf-button class="filter-item" type="success" size="mini" @success="goback()" plain>返回</qzf-button>
        <!-- <el-input placeholder="请输入姓名查询" v-model="cnName" style="width: 200px;" class="filter-item" size="mini" />
        <el-button class="filter-item" @click = chaxunname() type="primary" size="mini" plain>{{ $t('table.search') }}</el-button> -->
      </div>
      <div class="right_btns fr">
        <qzf-button type="primary" size="mini" @success="addPersonal" plain>添加</qzf-button>
        <qzf-button type="success" size="mini" @success="saveAll" plain v-loading.fullscreen.lock="fullscreenLoading">保存</qzf-button>
      </div>
    </div>
    <!-- 顶部按钮 end -->
    <!-- 上方信息 -->
    <div class="com_info">
      <div class="top_info">
        <div class="top_item">
          <p>企业类型：<span v-if="info.comType == ''">空</span><span v-else>{{info.comType}}</span></p>
          <p>征收方式：<span>{{info.wageType}}-据实预缴</span></p>
        </div>
      </div>
      <div class="bottom_info">
        <div class="info_list">
          <p>利润信息：</p>
          <span>
            收入总额：<el-input type="number" v-model.number="info.srAmount" style="width: 120px;" size="mini" @change="saveValue" />
            <el-button  type="primary" size="mini" plain @click="getValue">自动取值</el-button>
          </span>
          <span>
            成本费用：<el-input type="number" v-model.number="info.cbAmount" style="width: 120px;" size="mini" @change="saveValue" />
          </span>
          <span>
            利润总额：{{sum2}}
          </span>
          <span>
            弥补以前年度亏损：<el-input type="number" v-model.number="info.mbyqndks" style="width: 120px;" size="mini" @change="saveValue" />
          </span>
          <span>
            被投资单位经营所得：{{sum1}}
          </span>
        </div>
        <div class="bottom_info">
          <div class="info_list">
            <div class="wxts">温馨提示：若以下人员含有正常工资薪金并已享受减除费用，那么重复享受减除费用后，减除费用超出6万元则年度汇算清缴时将会产生补税，按实际情况可将投资者减除费用修改为0。</div>
          </div>
        </div>

      </div>
    </div>
    <!-- 上方信息 end -->
    <!-- 内容 -->
    <div class="content">
      <el-table :height="contentStyleObj" show-summary :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}" v-loading="listLoading" :data="listData" border fit highlight-current-row style="width: 100%;" size="mini">
        <!-- <el-table-column fixed type="selection" align="center" width="35"/> -->
        <el-table-column fixed label="序号" type="index" align="center" width="55"></el-table-column>
        <el-table-column fixed label="姓名" align="center" min-width="200">
          <template #default="{row}">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分配比例%" align="center" min-width="150">
          <template #default="{row}">
            <span>
              {{row.stockPercent}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="投资者减除费用" align="center" min-width="150">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.costReduction"></span>
          </template>
        </el-table-column>
        <el-table-column label="准予扣除的捐赠额" align="center" min-width="150" class-name="action_btns">
          <template #default="{row}">
            <span>
              {{row.jzr}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="基本养老保险" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.deductSbPension"></span>
          </template>
        </el-table-column>
        <el-table-column label="基本医疗保险" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.deductSbMedical"></span>
          </template>
        </el-table-column>
        <el-table-column label="失业保险" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.deductSbUnemployment"></span>
          </template>
        </el-table-column>
        
        <el-table-column label="住房公积金" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.deductHouseFund"></span>
          </template>
        </el-table-column>
        <el-table-column label="商业健康保险" prop="cz" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.syx"></span>
          </template>
        </el-table-column>
        <el-table-column label="其他扣除" align="center" min-width="130">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.deductOther"></span>
          </template>
        </el-table-column>
        <el-table-column label="已缴纳税额" align="center" min-width="150">
          <template #default="{row}">
            <span><input type="text" v-model.number="row.yjnse"></span>
          </template>
        </el-table-column>
        <el-table-column label="减免税额" align="center" min-width="150" class-name="action_btns">
          <template #default="{row}">
            <span>
              <input type="text" v-model.number="row.jmse" disabled style="width:70%">
              <i class="el-icon-edit" @click="jmseDialog(scope.row)"></i>
              <!-- {{scope.row.jmse}} -->
            </span>
          </template>
        </el-table-column>
        <el-table-column label="应补（退）税额" align="center" min-width="150">
          <template #default="{row}">
            <span>{{ row.ybtse }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="120" class-name="small-padding fixed-width top_right_btns">
          <template #default="{row}">
            <el-tooltip content="删除" placement="top">
              <i class="el-icon-delete" @click="del(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 内容 end -->
  </div>
  <addNormal ref="addNormal" @success="getList" :type="'个人生产经营所得'"></addNormal>
</template>

<script>
import addNormal from './components/addNormal.vue'
import { getEaSalaryOnes,salayAutomaticValue,salarySheetInfo,salarySheetEdit,saveEaSalaryOneAll,deleteEaSalaryOne } from '@/api/salary.js'
export default {
  components: {
    addNormal
  },
  data() {
    return {
      info:{},
      listData:[],
      listQuery: {
        page: 1,
        limit: 20,
        sheetId: this.$store.getters["commons/params"].salaryPersonId
      },
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(280)
    this.init()
  },
  computed: {
    sum1(){
      let num = 0
      num = Number(this.info.srAmount) - Number(this.info.cbAmount) - Number(this.info.mbyqndks)
      return num.toFixed(2)
    },
    sum2(){
      let num = 0
      num = Number(this.info.srAmount) - Number(this.info.cbAmount)
      return num.toFixed(2)
    },
  },
  methods: {
    init() {
      this.getList()
      this.getSalarySheetInfo()
    },
    //添加
    addPersonal() {
      this.$refs.addNormal.openDialog()
    },
    // 获取取值信息
    getSalarySheetInfo() {
      salarySheetInfo({ id: this.$store.getters["commons/params"].salaryPersonId }).then(response => {
        this.info = response.data.data
      });
    },
    // 自动取值
    getValue(){
      salayAutomaticValue({}).then(res => {
        if(res.data.msg == 'success'){
          this.$message({
            type: "success",
            message: "取值成功"
          });
          this.getSalarySheetInfo({ id: this.$store.getters["commons/params"].salaryPersonId })
        }
      });
    },
    // 保存取值信息
    saveValue(){
      this.info.srAmount = Number(this.info.srAmount)
      this.info.cbAmount = Number(this.info.cbAmount)
      this.info.mbyqndks = Number(this.info.mbyqndks)
      salarySheetEdit(this.info).then(res => {
        if(res.data.msg == "success") {
          this.getSalarySheetInfo({ id: this.$store.getters["commons/params"].salaryPersonId })
        }
      });
    },
    del(e) {
      this.$confirm("确认删除该薪酬表", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteEaSalaryOne({ id: e.id }).then(res => {
          if(res.data.msg == "success") {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功"
            });
          }
          
        });
      })
    },
    //返回
    goback() {
      this.$router.push({
        path: "/input/remuneration/remuneration",
        name: "remuneration"
      });
    },
    //股东列表
    getList() {
      getEaSalaryOnes(this.listQuery).then(res => {
        if(res.data.data.list) {
          this.listData = res.data.data.list;
        }else{
          this.listData = []
        }
        
      })
    },
    // 右上角保存
    saveAll() {
      this.listData.map(v=>{
        v.name = v.name
        v.costReduction = Number(v.costReduction)
        v.jzr = v.jzr
        v.deductSbPension = Number(v.deductSbPension)
        v.deductSbMedical = Number(v.deductSbMedical)
        v.deductSbUnemployment = Number(v.deductSbUnemployment)
        v.deductHouseFund = Number(v.deductHouseFund)
        v.syx = Number(v.syx)
        v.deductOther = Number(v.deductOther)
        v.jmse = v.jmse
        v.yjnse = Number(v.yjnse)
        v.ybtse = Number(v.ybtse)
        if(v.costReduction == 0){
          this.statusW = false
        } else{
          this.statusW = false
        }
      })
      if(!this.statusW){
        saveEaSalaryOneAll(this.listData).then(res => {
          if(res.data.msg != "success"){
            this.$message.error(res.data.msg);
          }else{
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.$router.go(-1);
            // this.$store.dispatch("delCachedViewByName", "salary");
          }
        });
      }
      
    },
  }
}
</script>

<style lang="scss" scoped>
.com_info{
  width: 100%;
  margin: 0 auto;
  margin-bottom: 5px;
  .top_info{
    width: 100%;
    margin-bottom: 10px;
    .top_item{
      display: inline-block;
      p{
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        color: #333;
        line-height: 24px;
        margin-right: 20px;
        span{
          font-weight: normal;
        }
      }
    }
  }
  .bottom_info{
    width: 100%;
    margin: 0 auto;
    font-size: 14px;
    .info_list{
      p{
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        color: #333;
        line-height: 24px;
        font-size: 14px;
      }
      span{
        margin-right: 14px;
        font-size: 14px;
      }
      .wxts{
        color:red;
        font-size: 14px;
        margin-top: 15px;
        font-size: 14px;
      }
    }
    
  }
}
.top_btns {
  .left_search {
    float: left;
    width: 30% !important;
  }
}
.addBtn{
  position: relative;
  top:-15px;
}
.top_right_btns {
  i {
    margin: 0 5px;
    cursor: pointer;
    font-size: 18px;
    line-height: 24px;
  }
  .el-icon-edit{
    color: #f15a24; 
  }
  .el-icon-delete{
    color: #f56c6c; 
  }
}
.saveAll {
  position: fixed;
  bottom: 46px;
  left: 218px;
  opacity: 0.8;
  z-index: 2004;
}
table{
  table-layout: fixed;
}
.content{
  margin: 0 auto;
  span{
    line-height: 24px;
    font-size: 14px;
    color: #333;
  }
  tr{
    padding: 0;
    margin: 0;
    background: #fff;
  }
  input{
    width: 100%;
    line-height:24px;
    padding: 0 6px;
    font-size: 14px;
    text-align: right;
    padding-right: 12px;
    color: #333;
  }
}
.action_btns{
  text-align: center;
  i{
    font-size: 16px;
    cursor: pointer;
    line-height: 24px;
  }
  .el-icon-edit{
    color: #f15a24;
  }
  .el-icon-delete{
    color: #f56c6c;
  }
}
</style>
<style>
.el-tooltip__popper{ max-width:20%; }
.el-table td.action_btns{
  background: #eee !important;
}
</style>